import api from '../../api/api';

/**
 * WorkflowItemCode: 工作流的 Code
 * TargetEntityId: 工作流实体的 Id
 * StatusCode: 工作流节点的StatusCode, 比如 0001_Accepted(通过) 0001_Declined(拒绝), 具体还是通过GetRuntimeItem去获取
 * Remark: 审核的备注信息
 * OperatorId: 操作者ID,传当前登录用户的ID
 * OperatorName: 操作者Name,传当前登录用户的Name
 */
export default {
    // 获取审核流程信息
    GetWorkflowActivities(workflowItemCode: string, targetEntityId: string, success: any, failure: any) {
        const WorkFlowEntity = {
            workflowItemCode, targetEntityId,
        };
        api.handleGet('WorkflowRuntime/GetWorkflowActivities', WorkFlowEntity, success, failure);
    },

    // 获取工作流节点状态
    GetRuntimeItem(workflowItemCode: string, targetEntityId: string, success: any, failure: any) {
        const WorkFlowEntity = {
            workflowItemCode, targetEntityId,
        };
        api.handleGet('WorkflowRuntime/GetRuntimeItem', WorkFlowEntity, success, failure);
    },

    // 提交、开启工作流
    Submit(WorkflowItemCode: string, TargetEntityId: string, success: any, failure: any) {
        const WorkFlowEntity = {
            WorkflowItemCode, TargetEntityId,
        };
        api.handlePost('WorkflowRuntime/Submit', WorkFlowEntity, success, failure);
    },

    // 审核工作流
    Audit(WorkflowItemCode: string, TargetEntityId: string, StatusCode: string, Remark: string, success: any, failure: any) {
        const WorkFlowEntity = {
            WorkflowItemCode, TargetEntityId, StatusCode, Remark,
        };
        api.handlePost('WorkflowRuntime/Audit', WorkFlowEntity, success, failure);
    },

    // 撤销工作流
    Cancel(WorkflowItemCode: string, TargetEntityId: string, Remark: string, OperatorId: string, OperatorName: string, success: any, failure: any) {
        const WorkFlowEntity = {
            WorkflowItemCode, TargetEntityId, Remark, OperatorId, OperatorName,
        };
        api.handlePost('WorkflowRuntime/Cancel', WorkFlowEntity, success, failure);
    },
    // 重置工作流
    Reset(targetEntityId: string, success: any, failure: any) {
        api.handleGet('WorkflowRuntime/ResetWorkflow', { targetEntityId }, success, failure);
    },
};
